export const createGetLinkDetailsRequest = (id) => {
  return {
    url: "/public/linked_in/connect/" + id,
    method: "GET",
  };
};

export const createLinkedInConnectRequest = (
  id,
  code,
  redirect_uri,
  workspace_id,
  client_id
) => {
  return {
    url: "/public/linked_in/connect/" + id + "/connect",
    method: "POST",
    data: {
      code,
      redirect_uri,
      workspace_id,
      client_id,
    },
  };
};

export const createLinkedInMigrateRequest = (id, workspace_id, temp_token) => {
  return {
    url: "/public/linked_in/connect/" + id + "/migrate",
    method: "POST",
    data: {
      workspace_id,
      temp_token,
    },
  };
};

export const createGetPublicVoiceNoteLinkDetailsRequest = (id) => {
  return {
    url: "/public/notes/" + id,
    method: "GET",
  };
};

export const createGetPublicVoiceNoteLinkSignedUrlRequest = (id) => {
  return {
    url: "/public/notes/" + id + "/signed_upload_url",
    method: "POST",
  };
};

export const createGetPublicVoiceNoteV2SignedUploadUrlRequest = (id) => {
  return {
    url: "/public/notes/" + id + "/v2/signed_upload_url",
    method: "POST",
  };
};

export const createUpdatePublicVoiceNoteLinkRecordingRequest = (id, note) => {
  let created_from_source_type = note.createdFromSourceType;
  let created_from_source_value = note.createdFromSourceValue;
  return {
    url: "/public/notes/" + id + "/add_voice_recording_url",
    method: "POST",
    data: {
      created_from_source_type,
      created_from_source_value,
    },
  };
};

export const createGetPublicPostDetailsRequest = (id) => {
  return{
     url: "/public/posts/" + id,
     method: "GET"
  } 
}

export const createPublicPostFeedbackRequest = (postId, feedback_text, post_text, author_name) => {
  return {
      url: `/public/posts/${postId}/feedback_comments/`,
      method: "POST",
      data: {
          feedback_text,
          post_text,
          author_name
      },
  };
}

export const createGetPublicPostFeedbackRequest = (postId, per_page, page) => {
  return {
      url: `/public/posts/${postId}/feedback_comments`,
      method: "GET",
      params: {
          per_page,
          page
      },
  };
}